import React from 'react';
import { Poppins } from 'src/common';
import * as S from './MissingVariableBanner.styles';

interface MissingVariableBannerProps {
  /** Absent in read-only contexts (version snapshots) — the copy degrades to a plain statement. */
  onAddValues?: () => void;
}

/**
 * Details-page counterpart of the table's Missing-variables pill. The link opens the
 * Missing Variables populate modal (was "Edit this control" → edit modal until QA
 * round 3; copy placeholder pending sign-off).
 */
export const MissingVariableBanner: React.FC<MissingVariableBannerProps> = ({ onAddValues }) => (
  <S.Box data-cy="missing-variable-banner">
    <S.AlertIcon color="statusRed" cursorDefault />
    <Poppins px={14} color="prussianBlue">
      Missing required variable.
      {onAddValues ? (
        <>
          {' '}
          <span className="edit-link" onClick={onAddValues}>
            Add values
          </span>{' '}
          to resolve.
        </>
      ) : null}
    </Poppins>
  </S.Box>
);
